import { UIText1, UIText2, UIText3 } from '@cian/ui-kit';
import { COMMON_COMPONENT_PROPS } from '../const';

export const uiTexts = {
  UIText1: {
    ...COMMON_COMPONENT_PROPS,
    id: 'uiText1',
    component: UIText1,
    tagName: 'uitext1',
    block: {
      label: 'UIText1',
      category: 'Typography',
      content: '<UIText1>UIText1</UIText1>',
    },
  },

  UIText2: {
    ...COMMON_COMPONENT_PROPS,
    id: 'uiText2',
    component: UIText2,
    tagName: 'uitext2',
    block: {
      label: 'UIText2',
      category: 'Typography',
      content: '<UIText2>UIText2</UIText2>',
    },
  },

  UIText3: {
    ...COMMON_COMPONENT_PROPS,
    id: 'uiText3',
    component: UIText3,
    tagName: 'uitext3',
    block: {
      label: 'UIText3',
      category: 'Typography',
      content: '<UIText3>UIText3</UIText3>',
    },
  },
};
